import router from '../../router'

const state = {
    RouteName: '',
    isCollapse: false,
    upload_data:"",
    router_true:true,//路由是否跳转
    data_no_router:false,//路由弹框
    // from_path:'',
    to_path:'',

}
const actions = {
    RouterAuth: ({
        commit
    }) => {
        router.beforeEach((to, from, next) => {


            commit; from;next();
            // let token = localStorage.getItem('token');
            let token = sessionStorage.getItem('token');
            let is_google ="";
            if(JSON.parse(sessionStorage.getItem('is_google'))){
                is_google = JSON.parse(sessionStorage.getItem('is_google'));
            }
            

            if(Object.is(to.name, 'login')||Object.is(to.name, 'reg')||Object.is(to.name, 'reset_pwd')||Object.is(to.name, 'forget_pwd')||Object.is(to.name, 'upload')){
                if(token&&is_google==true){
                    next('/')
                    // console.log(1);
                    return false;
                }
                
            }else{
                if(!token||!is_google){
                    next("/login");
                    // console.log(3);
                    return false;
                }
                
            }
            
        })
    }
}

export default {
    namespaced: true,
    state,
    actions,
}